import { makeStyles, Theme } from '@material-ui/core';

import clsx from 'clsx';
import { ReactNode, useContext } from 'react';
import { getOnHoverScrollbarStyle } from '../../../styles';
import { WbSidebarConfigContext } from '../config';
import { useWbSidebarMobileState } from '../WbNavbarMobileStateContext';

type WbSidebarScrollWrapperProps = {
  hoverOnlyScrollbar?: boolean;
  children?: ReactNode;
};

const useStyles = makeStyles<
  Theme,
  { hoverOnlyScrollbar: boolean; itemHeight: number }
>(theme => ({
  root: props => ({
    flex: '0 1 auto !important',
    overflowX: 'hidden',
    width: '100%',
    minHeight: props.itemHeight,
    ...getOnHoverScrollbarStyle(theme, props.hoverOnlyScrollbar),
  }),
}));

export const WbSidebarScrollWrapper = ({
  hoverOnlyScrollbar = false,
  children,
}: WbSidebarScrollWrapperProps) => {
  const {
    sidebarConfig: { itemHeight },
  } = useContext(WbSidebarConfigContext);

  const { isMobile } = useWbSidebarMobileState();

  const classes = useStyles({ hoverOnlyScrollbar, itemHeight });

  if (isMobile) return <>{children}</>;

  return <div className={clsx(classes.root)}>{children}</div>;
};
